import React from "react";
import { SimpleCommentsStructure } from "structure/simple-comments";
import { CLICK, component, componentWithVariants, demoFile, feature, story, variant } from "system/demo";
import { ActionUpvote } from "../upvote";

demoFile('feature/comments/upvote');

const collections = {
    comment: [
        {key: 1, from: 'a', text: 'I love this movie!'},
        {key: 2, from: 'b', text: 'My comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.'},
        {key: 3, from: 'c', replyTo: 1, text: 'I think this movie is okay.'},
        {key: 4, from: 'a', replyTo: 2, text: 'This reply should be shown'},
        {key: 5, from: 'e', text: 'Comment with no replies'}
    ]
}


feature('Upvote', {
    structureKey: 'simplecomments',
    config: SimpleCommentsStructure.defaultConfig,
    features: {upvote: true},
    state: {collections}
});

componentWithVariants('ActionUpvote', ActionUpvote, {args: {commentKey: 1}}, [
    variant('Add Upvote', {
        state: {collections, personaKey: 'p'}
    }, [
        story('Upvote', [CLICK('upvote')])
    ]),
    variant('Remove Upvote', {
        state: {collections: {...collections, upvote: [{key: 1, comment: 1, from: 'p'}]}, personaKey: 'p'}
    }, [
        story('Undo', [CLICK('upvote')])
    ])
]);
